import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactNode } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 2,
    },
    mutations: {
      onSettled: (data: any, error) => {
        if (error) return;
        const isFailure =
          data?.success === false || data?.data?.success === false;
        if (isFailure) {
          throw new Error(
            data?.message ||
              data?.msg ||
              data?.data?.message ||
              'Operation failed'
          );
        }
      },
    },
  },
});

export function QueryProvider({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
